import React from 'react';
import { X } from 'lucide-react';

interface BannerProps {
  children: React.ReactNode;
  className?: string;
  position?: string;
  leftElement?: React.ReactNode;
  rightElement?: React.ReactNode;
  bgColor?: string;
  onClose?: () => void;
}

export function Banner({
  children,
  className = '',
  position = 'top-0',
  leftElement,
  rightElement,
  bgColor = 'bg-[#E34290]',
  onClose,
}: BannerProps) {
  return (
    <div
      className={`fixed ${position} left-0 right-0 w-screen z-[60] ${bgColor} text-white text-center py-1 text-xs sm:text-sm flex items-center justify-center h-8 sm:h-9 ${className}`}
    >
      {leftElement && <div className="absolute left-2 top-1/2 -translate-y-1/2">{leftElement}</div>}
      <div className="flex items-center gap-2">{children}</div>
      {(rightElement || onClose) && (
        <div className="absolute right-2 top-1/2 -translate-y-1/2 flex items-center gap-2">
          {rightElement}
          {onClose && (
            <button
              onClick={onClose}
              className="p-1 rounded bg-white/90 text-[#E34290] hover:bg-white transition-colors"
              aria-label="Close banner"
            >
              <X className="h-3 w-3 sm:h-4 sm:w-4" />
            </button>
          )}
        </div>
      )}
    </div>
  );
}
